export enum StagesEnum {
  CREATED = "CREATED",
  PRE_PLANNING = "PRE_PLANNING",
  PLANNING = "PLANNING",
  SALES_OFFER = "SALES_OFFER",
  SALES_CLOSED = "SALES_CLOSED",
  AFTER_SALES = "AFTER_SALES",
  COMPLETED = "COMPLETED",
}
